import { Link } from 'react-router-dom';

interface SectionTitleProps {
  title: string;
  highlight?: string;
  subtitle?: string;
  rightTag?: string;
  rightLink?: string;
}

export default function SectionTitle({ title, highlight, subtitle, rightTag, rightLink }: SectionTitleProps) {
  return (
    <div className="flex items-end justify-between mb-8">
      <div>
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
          {title}
          {highlight && (
            <span className="text-primary-500"> × {highlight}</span>
          )}
        </h2>
        {subtitle && (
          <p className="mt-2 text-sm text-foreground-500">{subtitle}</p>
        )}
      </div>
      {rightTag && (
        rightLink ? (
          <Link
            to={rightLink}
            className="px-4 py-2 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            {rightTag}
          </Link>
        ) : (
          <span className="px-4 py-2 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
            {rightTag}
          </span>
        )
      )}
    </div>
  );
}